import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/the-hanging-tree/",
    alias: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/the-hanging-tree/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/the-hanging-tree/results",
    name: "Results",
    component: () => import("../views/Results.vue"),
  },
  {
    path: "/the-hanging-tree/settings",
    name: "Settings",
    component: () => import("../views/Settings.vue"),
  },
  {
    path: "/the-hanging-tree/extra",
    name: "Extra",
    component: () => import("../views/Extra.vue"),
  },
  {
    path: "*",
    name: "PageNotFound",
    component: () => import("../views/PageNotFound.vue"),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
